
import { Vue, Component } from 'vue-property-decorator';
import AccountStatus from '@/features/auth/views/AccountStatus.vue';

@Component({
  components: {
    AccountStatus,
  },
})
export default class AccountDeleted extends Vue {}
